export const PRIMARY_BUTTON_CLASS =
    "  flex py-2 gap-2 underline items-center text-sm lg:text-base  font-medium text-Text_White font-Poppins h-8 lg:h-10  ";
export const PRIMARY_BUTTON_DISABLED_CLASS =
    " flex py-2 gap-2 underline items-end text-sm	 lg:text-base  font-medium text-Text_White font-Poppins h-8 lg:h-10 ";
export const BUTTON_IMAGE_CLASS = " w-4 h-4 sm:w-5 sm:h-5 ";
